module.exports = __webpack_public_path__ + "static/image/logo-family/logo_shopping_live.png?cbdd4a86";